import useSWR from 'swr'

/**
 * テキストの動的変更部分(開催回数)のテキストを取得する
 */
export function useDisplayItem() {

    const fetchAddress = `/competition/api/management/registeredDisplayItem`;
    // const fetchAddress = `http://localhost:3100/registeredDisplayItem/1`;

    const fetcher = () => fetch(fetchAddress).then(res => res.json());

    const {data, error, isLoading, mutate} = useSWR(`HeldTimes`, fetcher, {revalidateOnFocus:false, revalidateOnReconnect:false});

    return{
        displayItem: data,
        isLoadingDisplayItem: isLoading,
        isError: error,
        mutate,
    }
}